import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { Close, CreditCard } from "@material-ui/icons";
import RegularButton from "components/CustomButtons/Button";
import { animations } from "helpers/animations";
import { green } from "@material-ui/core/colors";

export const RequestCreditConditionsViewAlert = ({ setRequestCreditStatus }) => {
    const val = 500
    return (
        <Grid
            item
            xs={12}
            className={animations.fadeRight}
            style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                backgroundColor: `${ green[val] }`,
                color: "#f6f6f6",
                borderRadius: 8
            }}
        >
            <Typography>
                Esta cuenta ha sido desbloqueada para un único servicio
            </Typography>

            <CreditCard style={{ margin: 0, fontSize: 60 }} />

            <RegularButton
                justIcon
                round
                color="transparent"
                onClick={() => setRequestCreditStatus(false)}
                style={{
                    position: "absolute",
                    top: 5,
                    right: 10
                }}
            >
                <Close style={{ margin: 0 }} />
            </RegularButton>
        </Grid>
    );
};
